import Vue from 'vue';
import locale from 'element-ui/lib/locale';
import VueI18n from 'vue-i18n';

var l = require.context('element-ui/lib/locale/lang', false, /\.js$/);
var enLocale = l.keys().map(it => {
    var language = it.split(".")[1].split("/")[1];
    var value = l(it);
    var b = value.default || value;
    b.language = language;
    return b;
});
var lmesages = require.context('./langs/', false, /\.json$/);
var Locale = lmesages.keys().map(it => {
    var value = lmesages(it);
    var c = value.default || value;
    var index = (enLocale || []).findIndex((item) => item.language === c.language);
    var mesage = {
        message: {...c },
        el: {...enLocale[index].el },
        language: c.language,
        names: c.language
    };
    return mesage
})


const messages = {};
Locale.forEach(it => {
    messages[it.names] = it;
})

Vue.use(VueI18n);
const i18n = new VueI18n({
    locale: localStorage.getItem('localize_lang') || 'en',
    messages: messages,
    silentTranslationWarn: true
});

locale.i18n((key, value) => i18n.t(key, value));

export default i18n;


// WEBPACK FOOTER //
// ./src/components/language/index.js